import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-web",
  "use": "icon-web-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\" id=\"icon-web\">\r\n  <g transform=\"matrix(1 0 0 1 -445 -1563 )\">\r\n    <path d=\"M 127.901391625 64  C 127.901391625 28.653677875  99.288429375 0  63.991729625 0  C 29.206520875 0  0.914194875 27.826640125  0.098608375 62.462982125  L 0.098608375 65.54337975  C 0.914194875 100.173359875  29.206520875 128  63.991729625 128  C 99.288429375 128  127.901391625 99.346322125  127.901391625 64  Z M 96 37  L 96 91  L 32 91  L 32 37  L 96 37  Z \" fill-rule=\"nonzero\" fill=\"#cccccc\" stroke=\"none\" transform=\"matrix(1 0 0 1 445 1563 )\" />\r\n  </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/web.svg
// module id = oot7
// module chunks = 0